// Keep in sync with essential.utils.export.FileTypeEnum
const FILE_EXPORT_FORMAT_MAP = {
  Csv: {
    label: "csv",
    value: "csv",
  },
  Xlsx: {
    label: "xlsx",
    value: "xlsx",
  },
  Ods: {
    label: "ods",
    value: "ods",
  },
} as const satisfies OptionsMap

export type FileExportFormat = ExtractValue<
  typeof FILE_EXPORT_FORMAT_MAP
>

const _options = buildOptionsFromMap(FILE_EXPORT_FORMAT_MAP)

export const useFileExportFormatOptions = () => ({
  options: _options,
  getLabelForValue: (value: FileExportFormat) =>
    computed(
      () =>
        _options.find((option) => option.value === value)
          ?.label || ""
    ),
})
